import React from "react"

import { InputContext } from "./Input"
import { UseInputContextProps, useInputContext } from "./hooks/useInputContext"

interface InputContextProviderProps extends UseInputContextProps {
  children: React.ReactNode
}

export const InputContextProvider = React.memo(
  ({ children, ...rest }: InputContextProviderProps) => {
    const { inputContext } = useInputContext(rest)

    return (
      <InputContext.Provider value={inputContext}>
        {children}
      </InputContext.Provider>
    )
  }
)

InputContextProvider.displayName = "InputContextProvider"
